<template>
    <div class="reservation">
       <div>
        <img src="../assets/contact/contactus.png"  />
       </div>
            <div>
                <p style="position: relative;margin-left: 40px;font-size: 18px;">尊敬的客户：</p>
                <p style="position: relative;margin-left: 100px;font-size: 18px;">您好！</p>
                <p style="position: relative;margin-left: 90px;font-size: 18px;">【在线预约】是在其他联系方式之外有效让我们了解您的需求的另一种方式！通过在线预约模块，您可以在这里留下您的联系方式，</p>
                <p style="position: relative;margin-left: 70px;font-size: 18px;">同时可留言您的需求或者疑问。您留下的每字每句都是对我们三辰服饰的信任！！！</p>
            </div>
            <div>
                <p style="position: relative; text-align: center;font-size: 28px;color: red;">我想留言</p>            
            </div>
            <el-form ref="form" :model="form" :rules="rules" class="reservation-form" label-width="110px">
              <el-form-item label="您的姓名" prop="name">
                <el-input placeholder="请输入姓名" v-model.trim="form.name"></el-input>
              </el-form-item>

              <el-form-item label="您的电话" prop="phone">
                <el-input placeholder="请输入手机号" v-model.trim="form.phone"></el-input>
              </el-form-item>

              <el-form-item label="公司名称" prop="company">
                <el-input placeholder="请输入公司名称" v-model.trim="form.company"></el-input>
              </el-form-item>

              <el-form-item label="预约留言" prop="message">
                <el-input
                  type="textarea"
                  :rows="4"
                  placeholder="请描述您的需求/疑问"
                  v-model.trim="form.message">
                </el-input>
              </el-form-item>

              <el-form-item>
                <el-button type="danger" :loading="submitting" @click="upload" round>立即提交</el-button>
                <el-button :disabled="submitting" @click="reset">清空</el-button>
              </el-form-item>
            </el-form>
        
    </div>
    
</template>

<script>
import { addAmp } from "@/api/amp";
export default {
  name: 'reservation',
  data() {
    return {
      submitting: false,
      form: {
        name: '',
        phone: '',
        company: '',
        message: '',
      },
      rules: {
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1\d{10}$/, message: '手机号格式不正确', trigger: 'blur' },
        ],
        company: [{ required: true, message: '请输入公司名称', trigger: 'blur' }],
        message: [{ required: true, message: '请输入留言内容', trigger: 'blur' }],
      },
    }
  },
  methods:{
    reset() {
      this.$refs.form && this.$refs.form.resetFields()
    },
    async upload() {
      if (this.submitting) return
      const ok = await new Promise((resolve) => {
        this.$refs.form.validate((valid) => resolve(valid))
      })
      if (!ok) return

      this.submitting = true
      try {
        const amp = { ...this.form }
        const res = await addAmp(amp)
        if (res && res.data) {
          await this.$alert('感谢留言，我们将尽快给予反馈！', '留言反馈')
          this.reset()
        } else {
          this.$alert('提交失败，请稍后再试', '留言反馈')
        }
      } catch (e) {
        this.$alert('网络异常，请稍后再试', '留言反馈')
      } finally {
        this.submitting = false
      }
    },
  }

}
</script>

    <style>
    .reservation
    {
      position: relative;
      width: 80%;
      left: 10%;
      box-shadow: 0 0 5px 1px #999 ;  
      border-radius: 10px;
      padding: 1%;
    }

    .reservation-form{
      width: 60%;
      margin: 30px auto 10px;
      text-align: left;
    }

    @media (max-width: 900px) {
      .reservation-form{
        width: 92%;
      }
    }
    
    </style>
    
    
    